import { render, staticRenderFns } from "./SentTermsSuccessModal.vue?vue&type=template&id=f0b2f3e2&scoped=true&"
import script from "./SentTermsSuccessModal.vue?vue&type=script&lang=js&"
export * from "./SentTermsSuccessModal.vue?vue&type=script&lang=js&"
import style0 from "./SentTermsSuccessModal.vue?vue&type=style&index=0&id=f0b2f3e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b2f3e2",
  null
  
)

export default component.exports